import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ClaimStatsDto} from "../../auto-generated-server-dtos/adjuster/claim-stats/claim-stats-dto";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class GetClaimStatsService {

  constructor(private httpClient: HttpClient) { }

  getClaimStats(StartDate: Date, EndDate: Date, claimType: number) {
    return this.httpClient.get<ClaimStatsDto>(`${environment.apiServer}/Adjuster/Claim/GetClaimStats`, {params: {StartDate: StartDate.toISOString(), EndDate: EndDate.toISOString(), ClaimType: claimType}});
  }
}
